<template>
    <div>
        <modal name="modal-view-invoice" width="800px" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Consulter la facture</h2>
                    <button @click="$modal.hide('modal-view-invoice');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="selectedViewInvoice">
                    <iframe :src="selectedViewInvoice.document_url + '?view=true'" class="w-full h-[1100px]"></iframe>
                </div>
            </div>
        </modal>

        <div v-if="loadingGetFactures" class="text-center my-5">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        <div v-else>
            <div v-if="factures.length === 0" class="text-center my-5">
                <p>Aucune facture trouvée.</p>
            </div>
            <div v-else>
                <div class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                    <table class="w-full text-sm text-left">
                        <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                            <tr>
                                <th class="px-6 py-3">Numéro de facture</th>
                                <th class="px-6 py-3">Date</th>
                                <th class="px-6 py-3">Total TTC</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100">
                            <tr v-for="facture in factures" :key="facture.id" @click="selectedViewInvoice = facture; $modal.show('modal-view-invoice')" class="hover:bg-red-100 cursor-pointer transition">
                                <td class="px-6 py-3">{{ facture.num_invoice || (facture.invoice_number || '-') }}</td>
                                <td class="px-6 py-3">{{ facture.created_at | momentDate }}</td>
                                <td class="px-6 py-3">{{ facture.total_ttc }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        clientId: {
            required: true
        },
    },

    data() {
        return {
            factures: [],

            selectedViewInvoice: null,

            loadingGetFactures: false,
        }
    },

    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },

    methods: {
        async getFactures() {
            this.loadingGetFactures = true;
            let response = await this.$request.post('/clients/factures-summary', {
                client_id: this.clientId
            })
            this.factures = response
            this.loadingGetFactures = false;
        }
    },
    mounted () {
        this.getFactures();
    },
}
</script>

<style lang="scss" scoped>

</style>